import Editor from './editor';
import $ from 'jquery';
import { bind } from '@ember/runloop';
export default Editor.extend({
  propertyCleaners: null,
  init() {
    this._super();
    if (!this.get('propertyCleaners')) {
      this.set('propertyCleaners', []);
    }
  },
  didInsertElement() {
    this._super(...arguments);
    $(document).on(`click.background-${this.get('elementId')}`, bind(this, this._bodyClickHandler));
  },
  willDestroyElement() {
    this._super(...arguments);
    $(document).off(`click.background-${this.get('elementId')}`);
  },
  _bodyClickHandler(e) {
    let $target = $(e.target);
    let $this = $(this.element);
    if ($target[0] !== $this[0] && !$.contains($this[0], $target[0]) && this.get('editingState') !== 'initial') {
      this.send('dismiss');
    }
  },
  findEmailTemplateDatum(identifier) {
    return this.get('emailTemplateData').findBy('identifier', identifier);
  },
  runPropertyCleaners() {
    this.get('propertyCleaners').forEach(function (cleaner) {
      this[cleaner]();
    }, this);
  }
});